import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import useScrollPosition from "../../utilities/use-scroll-position"
import NavItems from "./nav-items"
import { useLocation } from "@reach/router"

const Menu = ({
  onDownloadClick,
  hideOnScroll = true,
  light_version = false,
}) => {
  const { scrollY } = useScrollPosition()
  const [isScrolled, setIsScrolled] = useState(false)
  const { pathname } = useLocation()
  const [topButton, setTopbutton] = useState<any>(
    <StaticImage src='../../images/cta-top.png' alt='Play Now' width={310} />
  )
  const excludedTopButton = ["/", "/free-coins", "/free-coins/"];

  useEffect(() => {
    setIsScrolled(hideOnScroll && scrollY >= 50);
  }, [scrollY])

  useEffect(() => {
    if (pathname === "/mobile-slots") {
      setTopbutton(
        <StaticImage
          src='../../images/get-the-app-top.png'
          alt='Play Now'
          width={310}
        />
      )
    } else {
      setTopbutton(
        <StaticImage
          src='../../images/cta-top.png'
          alt='Play Now'
          width={310}
        />
      )
    }
  }, [])

  return (
    <div className='menu-container fixed-top w-full mb-[-150px] hidden xl:block'>
      <div className='inner-container'>
        <div className='flex justify-between'>
          <div className='log-nav flex flex-1'>
            {light_version ? (
              <div className='p-5 flex justify-center items-center space-x-1'>
                <div>
                  <StaticImage
                    src='../../images/logo.png'
                    alt='Free Slots - Jackpot Party Casino'
                    width={140}
                  />
                </div>
                <div className='blog-link text-[#bb00b3] text-[15px] font-bold'>
                  BLOG
                </div>
              </div>
            ) : (
              <div className='p-5 flex justify-center items-center space-x-1'>
                <Link to={"/"}>
                  <StaticImage
                    src='../../images/logo.png'
                    alt='Free Slots - Jackpot Party Casino'
                    width={140}
                  />
                </Link>
                <div className='blog-link'>
                  <Link
                    to='/blog/'
                    className='text-[#bb00b3] text-[15px] font-bold'
                  >
                    BLOG
                  </Link>
                </div>
              </div>
            )}
            {!isScrolled && !light_version && (
              <nav className='flex flex-1 links'>
                <NavItems onOpenMenuClick={() => null} openMobileMenu={null} />
              </nav>
            )}
          </div>
          {topButton && (
            <div
              className={
                !excludedTopButton.find((item) => pathname === item)
                  ? "cta cursor-pointer"
                  : `cta cursor-pointer relative transition-all ease-in-out duration-500 ${
                      isScrolled ? "top-0" : "top-[-150px]"
                    }`
              }
              onClick={onDownloadClick}
            >
              {topButton}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Menu
